export default function ({ route, store }) {
  const regexp =
    /(?<territory>[a-zA-Z]{2}-[a-zA-Z]{2})?\/?(?<website>health2?|tribal|experience|creative)?/gm

  if (route.params.pathMatch) {
    const match = regexp.exec(route.params.pathMatch)
    if (match) {
      const territory = match.groups.territory || process.env.NUXT_ENV_TERRITORY
      const website = match.groups.website || process.env.NUXT_ENV_WEBSITE

      if (!store.state.settings || territory !== store.state.territory) {
        store.commit('globals/SET_TERRITORY', territory)
      }
      if (!store.state.settings || territory !== store.state.website) {
        store.commit('globals/SET_WEBSITE', website)
      }
    }
  }
}
